var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"flex items-center justify-center h-screen"},[_c('div',{staticClass:"text-center"},[_c('i',{staticClass:"fas fa-spinner fa-spin text-4xl text-slate-600"}),_c('p',{staticClass:"mt-4 text-lg text-gray-700"},[_vm._v("Vérification du lien de connexion...")])])])])
}]

export { render, staticRenderFns }